"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5266],{

/***/ 95266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useGameActionHook_hook; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useWindowHook.hook.js
var useWindowHook_hook = __webpack_require__(89514);
// EXTERNAL MODULE: ./src/features/auth/useAuth.js + 3 modules
var useAuth = __webpack_require__(37671);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./services/getToken.js
var getToken = __webpack_require__(46583);
// EXTERNAL MODULE: ./services/api/fetchData.js
var fetchData = __webpack_require__(65925);
;// CONCATENATED MODULE: ./services/api/games/game.services.js






var GetGame = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _ref2,
        _ref2$gpId,
        gpId,
        _ref2$gameCategory,
        gameCategory,
        _ref2$from,
        from,
        _ref2$limit,
        limit,
        _ref2$orderBy,
        orderBy,
        token,
        payload,
        _args = arguments;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$gpId = _ref2.gpId, gpId = _ref2$gpId === void 0 ? [] : _ref2$gpId, _ref2$gameCategory = _ref2.gameCategory, gameCategory = _ref2$gameCategory === void 0 ? '' : _ref2$gameCategory, _ref2$from = _ref2.from, from = _ref2$from === void 0 ? 0 : _ref2$from, _ref2$limit = _ref2.limit, limit = _ref2$limit === void 0 ? 100 : _ref2$limit, _ref2$orderBy = _ref2.orderBy, orderBy = _ref2$orderBy === void 0 ? 'desc' : _ref2$orderBy;
            token = (0,getToken/* default */.Z)();
            payload = {
              gpId,
              gameCategory,
              from,
              limit,
              orderBy
            }; // const response = fetchData(payload, 'getgamelist2');
            // return response;

            return _context.abrupt("return", axios/* default.post */.Z.post(`${"https://pfe.w1nengine.com"}/v1/getgamelist2`, payload, {
              headers: {
                Authorization: token
              }
            }).then(function (response) {
              return response.data;
            }).catch(function (error) {
              throw error;
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function GetGame() {
    return _ref.apply(this, arguments);
  };
}();

var GetGameProvider = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var _response;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return (0,fetchData/* fetchData */.rQ)(null, '/game-provider');

          case 3:
            _response = _context2.sent;
            return _context2.abrupt("return", _response.data);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            throw _context2.t0.data;

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function GetGameProvider() {
    return _ref3.apply(this, arguments);
  };
}();

var GetPopularGames = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
    var _response2;

    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return (0,fetchData/* fetchData */.rQ)(null, 'getPopularGame');

          case 3:
            _response2 = _context3.sent;
            return _context3.abrupt("return", _response2.result);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            throw _context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.data;

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function GetPopularGames() {
    return _ref4.apply(this, arguments);
  };
}();

var GetLastPlayedGames = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    var _response3;

    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return (0,fetchData/* fetchData */.rQ)(null, 'lastPlayGames');

          case 3:
            _response3 = _context4.sent;
            return _context4.abrupt("return", _response3);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            throw _context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.data;

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function GetLastPlayedGames() {
    return _ref5.apply(this, arguments);
  };
}();

var GetGameUrl = /*#__PURE__*/function () {
  var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(_ref6) {
    var game, gameLanguage, token, _yield$fetch, _reqBody, _response4;

    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            game = _ref6.game, gameLanguage = _ref6.gameLanguage, token = _ref6.token;
            _context5.prev = 1;
            _reqBody = {
              gpId: `${game.gpId}`.toUpperCase(),
              gpGameId: `${game.gpGameId}`,
              gameLanguage
            };
            _context5.next = 5;
            return fetch(`${"https://pfe.w1nengine.com"}/v1/getGameUrl`, {
              method: 'POST',
              body: JSON.stringify(_reqBody),
              headers: {
                Authorization: token
              }
            });

          case 5:
            _context5.t1 = _yield$fetch = _context5.sent;
            _context5.t0 = _context5.t1 === null;

            if (_context5.t0) {
              _context5.next = 9;
              break;
            }

            _context5.t0 = _yield$fetch === void 0;

          case 9:
            if (!_context5.t0) {
              _context5.next = 13;
              break;
            }

            _context5.t2 = void 0;
            _context5.next = 14;
            break;

          case 13:
            _context5.t2 = _yield$fetch.json();

          case 14:
            _context5.next = 16;
            return _context5.t2;

          case 16:
            _response4 = _context5.sent;
            return _context5.abrupt("return", _response4);

          case 20:
            _context5.prev = 20;
            _context5.t3 = _context5["catch"](1);
            throw Error('game not found!');

          case 23:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 20]]);
  }));

  return function GetGameUrl(_x) {
    return _ref7.apply(this, arguments);
  };
}();

var GetDemoGameUrl = /*#__PURE__*/function () {
  var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(_ref8) {
    var game, token, _yield$fetch2, _reqBody2, _response5;

    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            game = _ref8.game;
            token = (0,getToken/* default */.Z)();
            _context6.prev = 2;
            _reqBody2 = {
              gpId: `${game.gpId}`.toUpperCase(),
              gpGameId: `${game.gpGameId}`
            };
            _context6.next = 6;
            return fetch(`${"https://pfe.w1nengine.com"}/v1/demo-get-game-url`, {
              method: 'POST',
              body: JSON.stringify(_reqBody2),
              headers: {
                Authorization: token
              }
            });

          case 6:
            _context6.t1 = _yield$fetch2 = _context6.sent;
            _context6.t0 = _context6.t1 === null;

            if (_context6.t0) {
              _context6.next = 10;
              break;
            }

            _context6.t0 = _yield$fetch2 === void 0;

          case 10:
            if (!_context6.t0) {
              _context6.next = 14;
              break;
            }

            _context6.t2 = void 0;
            _context6.next = 15;
            break;

          case 14:
            _context6.t2 = _yield$fetch2.json();

          case 15:
            _context6.next = 17;
            return _context6.t2;

          case 17:
            _response5 = _context6.sent;
            return _context6.abrupt("return", _response5);

          case 21:
            _context6.prev = 21;
            _context6.t3 = _context6["catch"](2);
            return _context6.abrupt("return", _context6.t3);

          case 24:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[2, 21]]);
  }));

  return function GetDemoGameUrl(_x2) {
    return _ref9.apply(this, arguments);
  };
}();

var GetDemoGameUrl2 = /*#__PURE__*/function () {
  var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(_ref10) {
    var game, token, _yield$fetch3, _reqBody3, _response6;

    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            game = _ref10.game, token = _ref10.token;
            _context7.prev = 1;
            _reqBody3 = {
              gpId: `${game.gpId}`.toUpperCase(),
              gpGameId: `${game.gpGameId}`
            };
            _context7.next = 5;
            return fetch(`${"https://pfe.w1nengine.com"}/v1/demo-get-game-url`, {
              method: 'POST',
              body: JSON.stringify(_reqBody3),
              headers: {
                Authorization: token
              }
            });

          case 5:
            _context7.t1 = _yield$fetch3 = _context7.sent;
            _context7.t0 = _context7.t1 === null;

            if (_context7.t0) {
              _context7.next = 9;
              break;
            }

            _context7.t0 = _yield$fetch3 === void 0;

          case 9:
            if (!_context7.t0) {
              _context7.next = 13;
              break;
            }

            _context7.t2 = void 0;
            _context7.next = 14;
            break;

          case 13:
            _context7.t2 = _yield$fetch3.json();

          case 14:
            _context7.next = 16;
            return _context7.t2;

          case 16:
            _response6 = _context7.sent;
            return _context7.abrupt("return", _response6);

          case 20:
            _context7.prev = 20;
            _context7.t3 = _context7["catch"](1);
            return _context7.abrupt("return", _context7.t3);

          case 23:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 20]]);
  }));

  return function GetDemoGameUrl2(_x3) {
    return _ref11.apply(this, arguments);
  };
}();

var GetSBOGameUrl = /*#__PURE__*/function () {
  var _ref13 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(_ref12) {
    var token, _yield$fetch4, _reqBody4, _response7;

    return regenerator_default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            token = _ref12.token;
            _context8.prev = 1;
            _reqBody4 = {
              Portfolio: 'SportsBook'
            };
            _context8.next = 5;
            return fetch(`${"https://pfe.w1nengine.com"}/v1/getGameSbo`, {
              method: 'POST',
              body: JSON.stringify(_reqBody4),
              headers: {
                Authorization: token
              }
            });

          case 5:
            _context8.t1 = _yield$fetch4 = _context8.sent;
            _context8.t0 = _context8.t1 === null;

            if (_context8.t0) {
              _context8.next = 9;
              break;
            }

            _context8.t0 = _yield$fetch4 === void 0;

          case 9:
            if (!_context8.t0) {
              _context8.next = 13;
              break;
            }

            _context8.t2 = void 0;
            _context8.next = 14;
            break;

          case 13:
            _context8.t2 = _yield$fetch4.json();

          case 14:
            _context8.next = 16;
            return _context8.t2;

          case 16:
            _response7 = _context8.sent;
            return _context8.abrupt("return", _response7);

          case 20:
            _context8.prev = 20;
            _context8.t3 = _context8["catch"](1);
            return _context8.abrupt("return", _context8.t3);

          case 23:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[1, 20]]);
  }));

  return function GetSBOGameUrl(_x4) {
    return _ref13.apply(this, arguments);
  };
}();

var SearchGames = /*#__PURE__*/function () {
  var _ref14 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(payload) {
    var _response8;

    return regenerator_default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _response8 = (0,fetchData/* fetchData */.rQ)(payload, 'searchGame');
            return _context9.abrupt("return", _response8);

          case 5:
            _context9.prev = 5;
            _context9.t0 = _context9["catch"](0);
            throw _context9.t0.response;

          case 8:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 5]]);
  }));

  return function SearchGames(_x5) {
    return _ref14.apply(this, arguments);
  };
}();

var GameServices = {
  GetGame,
  GetGameUrl,
  GetGameProvider,
  GetDemoGameUrl,
  GetDemoGameUrl2,
  GetSBOGameUrl,
  GetPopularGames,
  GetLastPlayedGames,
  SearchGames
};
/* harmony default export */ var game_services = (GameServices);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./src/features/modal/useModalStore.jsx
var useModalStore = __webpack_require__(73328);
// EXTERNAL MODULE: ./src/core/routes.js
var routes = __webpack_require__(58061);
;// CONCATENATED MODULE: ./hooks/useGameActionHook.hook.js










var useGameActionHook = function useGameActionHook() {
  var _useWindowHook = (0,useWindowHook_hook/* default */.Z)(),
      isMobile = _useWindowHook.isMobile;

  var _useAuth = (0,useAuth/* default */.Z)(),
      loginToken = _useAuth.loginToken,
      sessionToken = _useAuth.sessionToken;

  var _useModalStore = (0,useModalStore/* default */.Z)(function (state) {
    return {
      openModal: state.openModal
    };
  }),
      openModal = _useModalStore.openModal;

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = (0,react.useState)({
    gameUrl: null,
    gameUrlType: undefined
  }),
      game = _useState2[0],
      setGame = _useState2[1];

  var getGameUrlFunction = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(isDemo, game) {
      var _gameRes$type;

      var token, getGameUrlPayload, gameRes, _gameRes$message, finalGame;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              token = loginToken || sessionToken; // if (!token) {
              // 	openModal('login'); // Open login modal if no token is found
              // 	return null;
              // }

              getGameUrlPayload = {
                gpId: game.pi,
                gpGameId: game.gi
              };

              if (!isDemo) {
                _context.next = 8;
                break;
              }

              _context.next = 5;
              return game_services.GetDemoGameUrl2({
                game: getGameUrlPayload,
                token
              });

            case 5:
              _context.t0 = _context.sent;
              _context.next = 11;
              break;

            case 8:
              _context.next = 10;
              return game_services.GetGameUrl({
                game: getGameUrlPayload,
                token,
                language: localStorage.getItem('lang') || 'en-US'
              });

            case 10:
              _context.t0 = _context.sent;

            case 11:
              gameRes = _context.t0;

              if (!(gameRes !== null && gameRes !== void 0 && gameRes.error)) {
                _context.next = 15;
                break;
              }

              react_toastify_esm/* toast.error */.Am.error((_gameRes$message = gameRes === null || gameRes === void 0 ? void 0 : gameRes.message) !== null && _gameRes$message !== void 0 ? _gameRes$message : 'Error fetching game data.');
              return _context.abrupt("return", null);

            case 15:
              finalGame = {
                gameUrlType: (_gameRes$type = gameRes === null || gameRes === void 0 ? void 0 : gameRes.type) !== null && _gameRes$type !== void 0 ? _gameRes$type : undefined,
                gameUrl: isMobile && gameRes.gameUrl.mobile ? gameRes.gameUrl.mobile : gameRes.gameUrl.desktop
              }; // setGame(finalGame);

              return _context.abrupt("return", finalGame);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getGameUrlFunction(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var routerGameHtmlUrl = (0,react.useCallback)(function (gameUrl) {
    var blob = new Blob([gameUrl.gameUrl], {
      type: 'text/html'
    });
    var url = URL.createObjectURL(blob);

    if (isMobile) {
      window.location.replace(url);
      URL.revokeObjectURL(url); // Clean up the blob URL after navigating.
    } else {
      setGame({
        gameUrl: url
      });
    }
  }, [isMobile]);
  var routerGameDefaultUrl = (0,react.useCallback)(function (gameUrl, game) {
    if (isMobile) {
      window.location.replace(gameUrl.gameUrl);
    } else {
      if (['HKB', 'AP', 'SBO'].includes(game === null || game === void 0 ? void 0 : game.pi)) {
        window.location.replace(gameUrl.gameUrl);
      } else {
        setGame(gameUrl); // Assuming this state is for an iframe or other component.
      }
    }
  }, [isMobile]);
  var launchGameUrl = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(isDemo, game) {
      var isDemoNew, _gameData;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isDemoNew = Number(isDemo);
              setIsLoading(true);
              _context2.prev = 2;

              if (!(!isDemoNew && !loginToken || !sessionToken)) {
                _context2.next = 7;
                break;
              }

              openModal('login');
              setIsLoading(false);
              return _context2.abrupt("return");

            case 7:
              _context2.next = 9;
              return getGameUrlFunction(isDemoNew, game);

            case 9:
              _gameData = _context2.sent;

              if (_gameData) {
                _context2.next = 13;
                break;
              }

              react_toastify_esm/* toast.error */.Am.error('Failed to get game URL.');
              return _context2.abrupt("return");

            case 13:
              // Early exit if there's an error or no game URL.
              if (_gameData.gameUrlType === 'htmlContent') {
                routerGameHtmlUrl(_gameData, game);
              } else {
                routerGameDefaultUrl(_gameData, game);
              }

              _context2.next = 20;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](2);
              setGame({
                gameUrl: null,
                gameUrlType: undefined
              });
              react_toastify_esm/* toast.error */.Am.error('Failed to get game URL. Please try again.');

            case 20:
              _context2.prev = 20;
              setIsLoading(false);
              return _context2.finish(20);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 16, 20, 23]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(), [routerGameHtmlUrl, routerGameDefaultUrl, loginToken, sessionToken, openModal]);
  var gameRouterPush = (0,react.useCallback)(function () {
    var isDemo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var game = arguments.length > 1 ? arguments[1] : undefined;

    if (!isDemo && !loginToken || !sessionToken) {
      openModal('login');
      setIsLoading(false);
      return;
    }

    if (isMobile) {
      window.open(`${routes/* default.PLAY.LAUNCH_GAME */.Z.PLAY.LAUNCH_GAME}?gpId=${game === null || game === void 0 ? void 0 : game.pi}&gpGameId=${game === null || game === void 0 ? void 0 : game.gi}&isDemo=${isDemo}`, '_blank');
    } else {
      window.open(`${routes/* default.PLAY.GAME */.Z.PLAY.GAME}?gpId=${game === null || game === void 0 ? void 0 : game.pi}&gpGameId=${game === null || game === void 0 ? void 0 : game.gi}&isDemo=${isDemo}`, '_blank');
    }
  }, [isMobile, loginToken, sessionToken, openModal]);
  return {
    gameRouterPush,
    launchGameUrl,
    isLoading,
    game
  };
};

/* harmony default export */ var useGameActionHook_hook = (useGameActionHook);

/***/ }),

/***/ 73328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_midas_player_frontend_midas_player_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73445);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_midas_player_frontend_midas_player_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var modalComponents = {
  register: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(4617), __webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(8058), __webpack_require__.e(8582), __webpack_require__.e(658)]).then(__webpack_require__.bind(__webpack_require__, 658));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(658)];
      }
    }
  }),
  forgot_password: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(4617), __webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(3428), __webpack_require__.e(2055)]).then(__webpack_require__.bind(__webpack_require__, 52055));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(52055)];
      }
    }
  }),
  login: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(4617), __webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(8058), __webpack_require__.e(8582), __webpack_require__.e(721)]).then(__webpack_require__.bind(__webpack_require__, 60721));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(60721)];
      }
    }
  }),
  topup_togel: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(7612), __webpack_require__.e(2439)]).then(__webpack_require__.bind(__webpack_require__, 2439));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(2439)];
      }
    }
  }),
  transaction_history: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(4617), __webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(7050), __webpack_require__.e(3972)]).then(__webpack_require__.bind(__webpack_require__, 43972));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(43972)];
      }
    }
  }),
  change_email: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(4617), __webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(6475)]).then(__webpack_require__.bind(__webpack_require__, 89547));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(89547)];
      }
    }
  }),
  change_phone_number: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(4617), __webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(8003)]).then(__webpack_require__.bind(__webpack_require__, 80134));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(80134)];
      }
    }
  }),
  change_password: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(4617), __webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(3428), __webpack_require__.e(3323)]).then(__webpack_require__.bind(__webpack_require__, 93323));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(93323)];
      }
    }
  }),
  update_profile: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(8058), __webpack_require__.e(7486)]).then(__webpack_require__.bind(__webpack_require__, 57486));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(57486)];
      }
    }
  }),
  verify_account: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(3428), __webpack_require__.e(9522)]).then(__webpack_require__.bind(__webpack_require__, 9522));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(9522)];
      }
    }
  }),
  add_account: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(4617), __webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(8058), __webpack_require__.e(996)]).then(__webpack_require__.bind(__webpack_require__, 10996));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(10996)];
      }
    }
  }),
  deposit: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(7612), __webpack_require__.e(7747), __webpack_require__.e(8885)]).then(__webpack_require__.bind(__webpack_require__, 17740));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(17740)];
      }
    }
  }),
  wallet_balance: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(9866), __webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(6921)]).then(__webpack_require__.bind(__webpack_require__, 45918));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(45918)];
      }
    }
  })
};

function getModal(modalName) {
  var ModalComponent = modalComponents[modalName];
  return ModalComponent ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(ModalComponent, {}) : '';
}

var useModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* .create */ .Ue)(function (set) {
  return {
    data: {},
    modalIsOpen: false,
    modal: '',
    closeModal: function closeModal() {
      document.body.classList.remove('no-scroll');
      return set(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: {},
          modalIsOpen: false
        });
      });
    },
    openModal: function openModal(modalName) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      document.body.classList.add('no-scroll');
      return set(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: data,
          modalIsOpen: true,
          modal: getModal(modalName)
        });
      });
    }
  };
});
/* harmony default export */ __webpack_exports__["Z"] = (useModalStore);

/***/ })

}]);